import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const apiBase = () => (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

/**
 * Detects ?ref=CODE in the URL and:
 *  1. Stores the code in sessionStorage so the registration form can pre-fill it.
 *  2. Pings the backend ONCE per session+code so the mediator sees a visit count.
 */
export const ReferralTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = (params.get('ref') || '').toUpperCase().trim();
    if (!code) return;

    // Persist for the rest of the session (used by registration form)
    try {
      sessionStorage.setItem('loewenherz_referral_code', code);
    } catch { /* ignore */ }

    // Track only once per session for this code
    const trackedKey = `loewenherz_tracked_${code}`;
    try {
      if (sessionStorage.getItem(trackedKey)) return;
      sessionStorage.setItem(trackedKey, '1');
    } catch { /* if storage blocked, fall through and still track */ }

    fetch(apiBase() + '/api/mediators/track-visit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ referralCode: code }),
    }).catch(() => { /* silent */ });
  }, [location.search]);

  return null;
};
